export default "__VITE_ASSET__CLhdUszu__"